import { CSSObject } from '@chakra-ui/react';

export const GridLayout: CSSObject = {};
